module.exports = __webpack_public_path__ + "static/media/bonarka16.62d92d33.jpg";